import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { Subject } from 'rxjs';

// path globals
import { API_PATH, SUBSCRIPTION_KEY, GET_IMAGE_URL } from '../../shared/globals';

@Injectable({
  providedIn: 'root',
})
export class ImageByIdService {

  public imageUrlSubject$: Subject<any> = new Subject();

  constructor (
    private _http: HttpClient
  ) {}

  // getImageUrl(request) {

  //   this._http.post(API_PATH + GET_IMAGE_URL, request)
  //     .subscribe(
  //       res => {
  //         const imgUrl = API_PATH + res.imageUrl;
  //         this.imageUrlSubject$.next(imgUrl);
  //       },
  //       err => {
  //         this.imageUrlSubject$.next('error');
  //         return;
  //     });
  // }

  getImageUrl(request) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._http.post(API_PATH + GET_IMAGE_URL, request, {headers:headers})
      .subscribe(
        (res:any) => {
          const imgUrl = res.imageUrl;
          this.imageUrlSubject$.next(imgUrl);
        },
        err => {
          this.imageUrlSubject$.next('error');
          return;
      });
  }

};
